export default "__VITE_ASSET__CR04DE4d__"